module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/cv_3_sp_9b94a0c8ca819225ddf5557fce6105de.jpg";